import { round, applyMandatoryFeeSplit, sumTaxAmounts, getDisplayedTotalPrice } from '../../../utils';
import { PROPERTY_MANAGEMENT_GROUP } from '../../../config/constants';

const PAY_AT_DESTINATION_METHODS = ['op', 'paypal', 'amazon_pay'];

const isRateOrServiceTax = tax => tax.tax_type === 'rate' || tax.tax_type === 'service';

// GLOSARIO.md FCL-003 - logica centralizada en src/utils/utils.js (la reusan tambien
// Header.jsx y CustomerForm.jsx); se reexporta aqui para no romper los imports existentes.
export { applyMandatoryFeeSplit, sumTaxAmounts, getDisplayedTotalPrice };

export const summarizeTaxAmounts = taxes => {
  const allTaxes = [...taxes.included, ...taxes.nonIncluded];
  return {
    rateTaxes: round(sumTaxAmounts(allTaxes, isRateOrServiceTax)),
    nonRateTaxes: round(sumTaxAmounts(allTaxes, tax => !isRateOrServiceTax(tax))),
    nonIncludedTaxes: round(sumTaxAmounts(taxes.nonIncluded)),
  };
};

const buildPayAtDestinationPayments = ({ totalPrice, rateTaxes, nonRateTaxes, giftCodeDiscount, paymentPointsDiscount }) => [
  {
    text: '_%pagar ahora%_',
    amount: round(totalPrice + rateTaxes + round(giftCodeDiscount) + paymentPointsDiscount),
    isEquivalent: false,
  },
  {
    text: '_%pagar en el hotel%_',
    amount: nonRateTaxes,
    isEquivalent: false,
  },
];

const buildRequiredPrepaymentPayments = ({ requiredPrepaymentCalc }) => [
  {
    text: '_%pagar ahora%_',
    amount: requiredPrepaymentCalc,
    isEquivalent: false,
  },
];

const buildInstallmentPayments = ({ totalPrice }) => [
  {
    text: '_%pago a plazos%_',
    amount: totalPrice,
    isEquivalent: true,
  },
];

const buildDefaultPayment = ({
  summaryPriceBreakdown,
  totalPrice,
  totalPriceWithoutTaxes,
  nonIncludedTaxes,
  nonRateTaxes,
  giftCodeDiscount,
  paymentPointsDiscount,
  isHotelPayment,
  redeemPoints,
}) => {
  let amount;
  if (!summaryPriceBreakdown) {
    amount = round(totalPrice + round(giftCodeDiscount) + paymentPointsDiscount);
  } else {
    // GLOSARIO.md FCL-003 - la fee obligatoria (ya sumada en totalPriceWithoutTaxes) cuenta siempre
    // como parte del precio, se pague ahora o en el hotel, con o sin gift code/puntos aplicados.
    amount = round(totalPriceWithoutTaxes + nonIncludedTaxes + round(giftCodeDiscount) + paymentPointsDiscount);
  }
  // GLOSARIO.md FCL-003 - los puntos/voucher nunca pueden cubrir los taxes que no son de tarifa
  // (se pagan siempre en el hotel): si los descuentos dejan el importe por debajo, se fuerza el minimo.
  if (summaryPriceBreakdown && isHotelPayment) amount = Math.max(amount, nonRateTaxes);

  return [
    {
      text: isHotelPayment ? '_%pagar en el hotel%_' : '_%pagar ahora%_',
      amount,
      isEquivalent: (!!redeemPoints || !!giftCodeDiscount) ? false : true,
    },
  ];
};

export const buildPayments = params => {
  const { summaryPriceBreakdown, payformCode, requiredPrepaymentCalc, isHotelPayment } = params;

  if (summaryPriceBreakdown && PAY_AT_DESTINATION_METHODS.includes(payformCode)) {
    return buildPayAtDestinationPayments(params);
  }
  if (!!requiredPrepaymentCalc && isHotelPayment) {
    return buildRequiredPrepaymentPayments(params);
  }
  if (payformCode === 'bnpl') {
    return buildInstallmentPayments(params);
  }
  return buildDefaultPayment(params);
};

export const getTaxesInformationText = managementGroupID =>
  managementGroupID === PROPERTY_MANAGEMENT_GROUP
    ? '_%información sobre tasas y fees%_'
    : '_%información sobre impuestos%_';
